import {
	productSaga as products,
	blockSaga as blocks,
	blockingRulesSaga as blockingRules,
	sagaChannels as channels,
	massAssignProductSaga,
	externalFormSaga as externalForms,
	sagaRecommendation as recommendations,
	sagaBlackList as blackList,
	unblockRequestSaga as unBlockRequests,
	unblockRequestStatusSaga as unblockRequestStatuses,
	businessappsSaga as businessapps,
	sagaMerchantBranches as merchantBranches,
	blockProductGroup,
	externalFormLandingSaga,
} from 'Pages/orders'
import { all } from 'typed-redux-saga'

export function* ordersSaga() {
	yield* all([
		products(),
		recommendations(),
		merchantBranches(),
		blocks(),
		blockingRules(),
		unBlockRequests(),
		channels(),
		massAssignProductSaga(),
		unblockRequestStatuses(),
		externalForms(),
		blackList(),
		businessapps(),
		blockProductGroup(),
		externalFormLandingSaga(),
	])
}
